import UploadModal from './src/main'
export default {
  install(Vue, props) {
    Vue.prototype.$UploadModal = options => {
      UploadModal(options, props)
    }
  }
}
